<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordoglo/svgGlo26bg.svg" />

    <p id="tag01" class="textBase basicItem01 tagDefault">ABAJO</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">LA</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">DE</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">CAMA</p>
    <p id="tag05" class="textBase basicItem01 tagDefault">ESTÁ</p>

    <p id="tag11" class="textBase basicItem01 tagDefault">FLOR</p>
    <p id="tag12" class="textBase basicItem01 tagDefault">VIVE</p>
    <p id="tag13" class="textBase basicItem01 tagDefault">EN</p>
    <p id="tag14" class="textBase basicItem01 tagDefault">OCULTO</p>
    <p id="tag15" class="textBase basicItem01 tagDefault">UNA</p>

    <h1 id="text01" class="textBase textFormat21">¿ESTÁ</h1>
    <h1 id="text02" class="textBase textFormat21">¿VIVE</h1>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
    />
    <h1 id="quest1">?</h1>
    <h1 id="quest2">?</h1>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 39px;
  top: 167px;
}

#tag01 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 42px;
  top: 372px;
}
#tag02 {
  position: absolute;
  width: 70px;
  text-align: center;
  left: 278px;
  top: 372px;
}
#tag03 {
  position: absolute;
  width: 70px;
  text-align: center;
  left: 393px;
  top: 372px;
}
#tag04 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 40px;
  top: 464px;
}
#tag05 {
  position: absolute;
  width: 180px;
  text-align: center;
  text-decoration: line-through;
  left: 272px;
  top: 464px;
}

#tag11 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 532px;
  top: 372px;
}
#tag12 {
  position: absolute;
  width: 70px;
  text-align: center;
  text-decoration: line-through;
  left: 769px;
  top: 372px;
}
#tag13 {
  position: absolute;
  width: 70px;
  text-align: center;
  left: 887px;
  top: 372px;
}
#tag14 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 532px;
  top: 464px;
}
#tag15 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 766px;
  top: 464px;
}

#text01 {
  position: absolute;
  left: 40px;
  top: 590px;
}
#text02 {
  position: absolute;
  left: 550px;
  top: 590px;
}
#inputField01 {
  position: absolute;
  width: 414px;
  height: 52px;
  left: 39px;
  top: 646px;
}
#inputField02 {
  position: absolute;
  width: 420px;
  height: 52px;
  left: 545px;
  top: 646px;
}
h1 {
  color: #2bb673;
  z-index: 2;
  font-size: 34px;
  letter-spacing: 0.1em;
}
#quest1 {
  position: absolute;
  left: 450px;
  top: 637px;
}
#quest2 {
  position: absolute;
  left: 962px;
  top: 637px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 122.mp4",
        "glo/Video 124.mp4",
      ]
    }
  }
}
</script>